<script setup>
import { onMounted, ref } from 'vue';
import rewardItem from './rewardItem.vue';
import { get_reward_total, get_reward_histories } from '@/services/reward_histories';
import { numberWithCommas, swalError } from '@/helper';
const props = defineProps({
  user_id: {
    required: true
  }
})

const isLoading = ref(true)
onMounted(async()=>{
  await retrieve_total()
  await retrieve_histories()
  isLoading.value = false
})

const reward_total = ref(0)
async function retrieve_total(){
  let response = await get_reward_total(props.user_id)
  if (response.error){
    swalError(response.result, true)
    return
  }
  reward_total.value = response.result.data
}

const reward_histories = ref([])
async function retrieve_histories(){
  let response = await get_reward_histories(props.user_id)
  if (response.error){
    swalError(response.result, true)
    return
  }
  reward_histories.value = response.result.data.data
}
</script>

<template>
  <loadingCard v-if="isLoading"/>
  <div v-else class="card">
    <CardHeader title="Reward History" :is_narrow="true">
      <div class="position-absolute end-0 pe-4">
        <div class="badge badge-light-primary py-2 px-2"
          
        >
          <span>Point Collected : </span>
          {{ numberWithCommas(reward_total) }}
        </div>
      </div>
    </CardHeader>
    <div class="card-body">
      <EmptyCard :text="'No reward history yet'" v-if="reward_histories.length == 0" />
      <template v-else>
        <template v-for="history in reward_histories" :key="history.id">
          <rewardItem :history="history"/>
        </template>
      </template>
    </div>
  </div>
</template>